import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2 } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { NomadeService } from '../../../../../nomade/services/nomade.service'
import { StateService } from '../../../../../services/App/state.service'

@Component({
	selector: 'atyl-nomade-home',
	templateUrl: './nomade-home.component.html',
	styleUrls: ['./nomade-home.component.scss']
})
export class NomadeHomeComponent implements OnInit {


	constructor(
		private changeDetectorRef: ChangeDetectorRef,
		public nomadeService: NomadeService,
		private el: ElementRef,
		private render: Renderer2,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private stateService: StateService
	) { }

	questionAnswered: boolean = false
	dossiers: any[] = []
	consultations: any[] = []
	loading: boolean
	requestes: any[] = []
    dossiersLoaded: boolean = false;
    consultsLoaded: boolean = false;
	ngOnInit() {
		const isModeNomade = localStorage.getItem('ATYL_MODE_NOMADE')
		if (isModeNomade == 'true') {
			this.__load__menus__();
			this.__check__answer__()
			this.__load__dossiers__()
			this.__load__consultations__()
			this.loadCSS('./assets/css/style.bundle.css')
			this.__set__nomade__colors__()
			//this.__load__requestes__()
		}
	}
	private __load__requestes__() {
		this.nomadeService.requestes().subscribe(response => {
			console.log(response)
		})
	}
	private __load__consultations__() {
        this.nomadeService.consultations().subscribe((response: any[]) => {
            this.consultations=[];
            response.forEach((consultation, index) => {
				this.consultations.push(this.nomadeService.parse(consultation))
			})
            this.consultsLoaded = true;
            this.changeDetectorRef.detectChanges()
			console.log("NomadeHomeComponent __load__consultations__",this.consultations)
		})
	}

	private __check__answer__() {
		const answered = localStorage.getItem('questionAnswered')
		if (answered == 'true') {
			this.questionAnswered = true
		}
	}

	private __set__nomade__colors__() {
		document.documentElement.style.setProperty('--atyl-primary', '#00a8ff')
        document.documentElement.style.setProperty('--atyl-primary-dark', '#00559f')
		document.documentElement.style.setProperty('--atyl-accent', '#003176')
	}

	private __load__dossiers__() {
        this.dossiersLoaded = false;
		console.log("NomadeHomeComponent __load__dossiers__",this.dossiers)
		
		this.nomadeService.dossiers().subscribe(response => {
            this.dossiers=[];
			response.forEach(element => {
                this.dossiers.push(this.nomadeService.parse(element))
				
			})
            this.dossiersLoaded = true;
			this.changeDetectorRef.detectChanges()
			console.log("NomadeHomeComponent __load__dossiers__",this.dossiers)
		})
	}

	private __load__menus__() {
		console.log("NomadeHomeComponent __load__menus__")
		this.nomadeService.menus().subscribe(menus => {
			
			menus.forEach((menu)=> {
				if (menu.actions!=undefined)
					menu.actions=JSON.parse(menu.actions)
				else {
					menu.actions=[]
				}
			})
			console.log("NomadeHomeComponent __load__menus__",menus)
			this.stateService.updatePages(menus);
		})
			
	}

	showHideForm(event: boolean) {
		this.questionAnswered = event
		localStorage.setItem('questionAnswered', event.toString())
		this.changeDetectorRef.detectChanges()
	}

	tabDossierChange(event: MouseEvent) {
		console.log(event)
	}
	dossierSelected(event: any) {
		console.log(event)
		this.router.navigate([`/nomade_client/dossier/${event.id}`], {
			relativeTo: this.activatedRoute
		})
	}

	private loadCSS(styleUrl: string) {
		return new Promise((resolve, reject) => {
			const styleElement = document.createElement('link')
			styleElement.href = styleUrl
			styleElement.type = 'text/css'
			styleElement.rel = 'stylesheet'
			styleElement.onload = resolve
			this.render.appendChild(this.el.nativeElement, styleElement)
		})
	}

	consultationSelected(consultation: any): void {
		console.log(consultation)
		this.router.navigate([`/nomade_client/consultation/${consultation.id}`], {
			relativeTo: this.activatedRoute
		})
	}

}
